export default __webpack_public_path__ + "images/076dd81dd983f090c815c3a86008ed51-sikhism_small.webp";